var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import { Button } from '../../button';
import InputVertical from '../input/InputVertical';
var SearchForm = /** @class */ (function (_super) {
    __extends(SearchForm, _super);
    function SearchForm(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        _this.onSubmit = function (evt) {
            var onSubmit = _this.props.onSubmit;
            var searchValue = _this.state.searchValue;
            evt.preventDefault();
            onSubmit(searchValue);
        };
        _this.state = {
            searchValue: (_a = props.searchValue) !== null && _a !== void 0 ? _a : '',
        };
        return _this;
    }
    SearchForm.prototype.onChange = function (value) {
        var onChange = this.props.onChange;
        this.setState({ searchValue: value });
        onChange && onChange(value);
    };
    SearchForm.prototype.render = function () {
        var _this = this;
        var searchValue = this.state.searchValue;
        var _a = this.props, className = _a.className, size = _a.size, colorButtonSubmit = _a.colorButtonSubmit, isRounded = _a.isRounded, inputClassName = _a.inputClassName;
        return (React.createElement("form", { onSubmit: this.onSubmit, className: className },
            React.createElement("div", { className: 'd-flex align-items-center w-100' },
                React.createElement(InputVertical, { name: 'search', type: 'text', value: searchValue, placeholder: 'найти…', isRequired: false, size: size ? size : 'sm', inputClassName: ' card-search-inp ', className: 'mb-0 w-100 ' + (inputClassName ? inputClassName : ''), isRounded: isRounded, onChange: function (value) {
                        _this.onChange(value);
                    } }),
                React.createElement(Button, { isRoundedButton: isRounded, className: 'card-search-btn ml-n-i-x1', type: 'submit', size: size === 'lg' ? 'md' : 'sm', color: colorButtonSubmit || 'primary', onClick: this.onSubmit }, "\u041D\u0430\u0439\u0442\u0438"))));
    };
    return SearchForm;
}(Component));
export default SearchForm;
//# sourceMappingURL=SearchForm.js.map